module.exports = __webpack_public_path__ + "static/media/magic bricks_ipl campaign.e9c36ca7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/magic bricks_ipl campaign.gif
// module id = 386
// module chunks = 0